import { render, staticRenderFns } from "./DataManager.vue?vue&type=template&id=edfc02ce&scoped=true"
import script from "./DataManager.vue?vue&type=script&lang=js"
export * from "./DataManager.vue?vue&type=script&lang=js"
import style0 from "./DataManager.vue?vue&type=style&index=0&id=edfc02ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfc02ce",
  null
  
)

export default component.exports